import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { emitAll1gcsgxt89nibi as emitAll } from '../Channels.mjs';
import { BufferOverflow_SUSPEND_getInstanceob833ibjouyy as BufferOverflow_SUSPEND_getInstance } from '../../channels/BufferOverflow.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { CoroutineStart_ATOMIC_getInstance1d52yopvtltan as CoroutineStart_ATOMIC_getInstance } from '../../CoroutineStart.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { produce3s4oh9balbl5b as produce } from '../../channels/Produce.mjs';
import { coroutineScope39ukucf23mhsm as coroutineScope } from '../../CoroutineScope.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { EmptyCoroutineContext_instancegbhtm9svfl3r as EmptyCoroutineContext_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { get_classSimpleName2jgk6lzg9ft1 as get_classSimpleName } from '../../Debug.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { SendingCollector33jb503i6hglm as SendingCollector } from './SendingCollector.mjs';
import { newCoroutineContext1x74axajiiptk as newCoroutineContext } from '../../CoroutineContext.mjs';
import { Key_instance1cfwgdmm6vbbh as Key_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/ContinuationInterceptor.mjs';
import { NopCollector2h4omm21qc7hq as NopCollector } from './NopCollector.mjs';
import { threadContextElements12yd4mfmaodla as threadContextElements } from '../../internal/ThreadContext.mjs';
import { startCoroutineUninterceptedOrReturnGeneratorVersion1cv0wx9z0l0zn as startCoroutineUninterceptedOrReturnGeneratorVersion } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../FlowCollector.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/Continuation.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ChannelFlow$_get_collectToFun_$slambda_j53z2e(this$0) {
  return constructCallableReference(function *(it, $completion) {
    yield* this$0.e1d(it, $completion);
    return Unit_instance;
  }, 1);
}
function ChannelFlow$collect$slambda($collector, this$0) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    yield* emitAll($collector, this$0.m1d($this$coroutineScope), $completion);
    return Unit_instance;
  }, 1);
}
var ChannelFlowClass;
function ChannelFlow() {
  if (ChannelFlowClass === VOID) {
    class $ {
      constructor(context, capacity, onBufferOverflow) {
        this.f1d_1 = context;
        this.g1d_1 = capacity;
        this.h1d_1 = onBufferOverflow;
        // Inline function 'kotlinx.coroutines.assert' call
      }
      i1d() {
        return ChannelFlow$_get_collectToFun_$slambda_j53z2e(this);
      }
      j1d() {
        return this.g1d_1 === -3 ? -2 : this.g1d_1;
      }
      k1d(context, capacity, onBufferOverflow) {
        // Inline function 'kotlinx.coroutines.assert' call
        var newContext = context.pm(this.f1d_1);
        var newCapacity;
        var newOverflow;
        if (!onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance())) {
          newCapacity = capacity;
          newOverflow = onBufferOverflow;
        } else {
          var tmp;
          if (this.g1d_1 === -3) {
            tmp = capacity;
          } else if (capacity === -3) {
            tmp = this.g1d_1;
          } else if (this.g1d_1 === -2) {
            tmp = capacity;
          } else if (capacity === -2) {
            tmp = this.g1d_1;
          } else {
            // Inline function 'kotlinx.coroutines.assert' call
            // Inline function 'kotlinx.coroutines.assert' call
            var sum = this.g1d_1 + capacity | 0;
            tmp = sum >= 0 ? sum : 2147483647;
          }
          newCapacity = tmp;
          newOverflow = this.h1d_1;
        }
        if (equals(newContext, this.f1d_1) && newCapacity === this.g1d_1 && newOverflow.equals(this.h1d_1))
          return this;
        return this.d1d(newContext, newCapacity, newOverflow);
      }
      m1d(scope) {
        return produce(scope, this.f1d_1, this.j1d(), this.h1d_1, CoroutineStart_ATOMIC_getInstance(), VOID, this.i1d());
      }
      *y1c(collector, $completion) {
        return yield* coroutineScope(ChannelFlow$collect$slambda(collector, this), $completion);
      }
      n1d() {
        return null;
      }
      toString() {
        var props = ArrayList().h2(4);
        var tmp0_safe_receiver = this.n1d();
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          props.i2(tmp0_safe_receiver);
        }
        if (!(this.f1d_1 === EmptyCoroutineContext_instance)) {
          props.i2('context=' + toString(this.f1d_1));
        }
        if (!(this.g1d_1 === -3)) {
          props.i2('capacity=' + this.g1d_1);
        }
        if (!this.h1d_1.equals(BufferOverflow_SUSPEND_getInstance())) {
          props.i2('onBufferOverflow=' + this.h1d_1.toString());
        }
        return get_classSimpleName(this) + '[' + joinToString(props, ', ') + ']';
      }
    }
    protoOf($).l1d = fuse$default;
    initMetadataForClass($, 'ChannelFlow', VOID, VOID, [FusibleFlow()], [1]);
    ChannelFlowClass = $;
  }
  return ChannelFlowClass;
}
function fuse$default(context, capacity, onBufferOverflow, $super) {
  context = context === VOID ? EmptyCoroutineContext_instance : context;
  capacity = capacity === VOID ? -3 : capacity;
  onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
  return $super === VOID ? this.k1d(context, capacity, onBufferOverflow) : $super.k1d.call(this, context, capacity, onBufferOverflow);
}
var FusibleFlowClass;
function FusibleFlow() {
  if (FusibleFlowClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'FusibleFlow', VOID, VOID, VOID, [1]);
    FusibleFlowClass = $;
  }
  return FusibleFlowClass;
}
var ChannelFlowOperatorImplClass;
function ChannelFlowOperatorImpl() {
  if (ChannelFlowOperatorImplClass === VOID) {
    class $ extends ChannelFlowOperator() {
      constructor(flow, context, capacity, onBufferOverflow) {
        context = context === VOID ? EmptyCoroutineContext_instance : context;
        capacity = capacity === VOID ? -3 : capacity;
        onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
        super(flow, context, capacity, onBufferOverflow);
      }
      d1d(context, capacity, onBufferOverflow) {
        return new (ChannelFlowOperatorImpl())(this.i1g_1, context, capacity, onBufferOverflow);
      }
      *j1g(collector, $completion) {
        return yield* this.i1g_1.y1c(collector, $completion);
      }
    }
    initMetadataForClass($, 'ChannelFlowOperatorImpl', VOID, VOID, VOID, [1]);
    ChannelFlowOperatorImplClass = $;
  }
  return ChannelFlowOperatorImplClass;
}
function *collectWithContextUndispatched($this, collector, newContext, $completion) {
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$0 = $completion.pc();
  var originalContextCollector = withUndispatchedContextCollector(collector, tmp$ret$0);
  return yield* withContextUndispatched(newContext, originalContextCollector, VOID, ChannelFlowOperator$collectWithContextUndispatched$slambda($this), $completion);
}
function ChannelFlowOperator$collectWithContextUndispatched$slambda(this$0) {
  return constructCallableReference(function *(it, $completion) {
    yield* this$0.j1g(it, $completion);
    return Unit_instance;
  }, 1);
}
var ChannelFlowOperatorClass;
function ChannelFlowOperator() {
  if (ChannelFlowOperatorClass === VOID) {
    class $ extends ChannelFlow() {
      constructor(flow, context, capacity, onBufferOverflow) {
        super(context, capacity, onBufferOverflow);
        this.i1g_1 = flow;
      }
      *e1d(scope, $completion) {
        return yield* this.j1g(new (SendingCollector())(scope), $completion);
      }
      *y1c(collector, $completion) {
        if (this.g1d_1 === -3) {
          // Inline function 'kotlin.js.getCoroutineContext' call
          var collectContext = $completion.pc();
          var newContext = newCoroutineContext(collectContext, this.f1d_1);
          if (equals(newContext, collectContext))
            return yield* this.j1g(collector, $completion);
          if (equals(newContext.bd(Key_instance), collectContext.bd(Key_instance)))
            return yield* /*#__NOINLINE__*/collectWithContextUndispatched(this, collector, newContext, $completion);
        }
        yield* protoOf(ChannelFlow()).y1c.call(this, collector, $completion);
        return Unit_instance;
      }
      toString() {
        return toString(this.i1g_1) + ' -> ' + super.toString();
      }
    }
    initMetadataForClass($, 'ChannelFlowOperator', VOID, VOID, VOID, [1, 2]);
    ChannelFlowOperatorClass = $;
  }
  return ChannelFlowOperatorClass;
}
function withUndispatchedContextCollector(_this__u8e3s4, emitContext) {
  var tmp;
  var tmp_0;
  if (_this__u8e3s4 instanceof SendingCollector()) {
    tmp_0 = true;
  } else {
    tmp_0 = _this__u8e3s4 instanceof NopCollector();
  }
  if (tmp_0) {
    tmp = _this__u8e3s4;
  } else {
    tmp = new (UndispatchedContextCollector())(_this__u8e3s4, emitContext);
  }
  return tmp;
}
function *withContextUndispatched(newContext, value, countOrElement, block, $completion) {
  countOrElement = countOrElement === VOID ? threadContextElements(newContext) : countOrElement;
  // Inline function 'kotlinx.coroutines.withCoroutineContext' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var tmp0 = block;
    var tmp2 = value;
    // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
    var completion = new (StackFrameContinuation())(uCont, newContext);
    return startCoroutineUninterceptedOrReturnGeneratorVersion(tmp0, tmp2, completion);
  };
}
function UndispatchedContextCollector$emitRef$slambda($downstream) {
  return constructCallableReference(function *(it, $completion) {
    yield* $downstream.v1d(it, $completion);
    return Unit_instance;
  }, 1);
}
var UndispatchedContextCollectorClass;
function UndispatchedContextCollector() {
  if (UndispatchedContextCollectorClass === VOID) {
    class $ {
      constructor(downstream, emitContext) {
        this.k1g_1 = emitContext;
        this.l1g_1 = threadContextElements(this.k1g_1);
        var tmp = this;
        tmp.m1g_1 = UndispatchedContextCollector$emitRef$slambda(downstream);
      }
      *v1d(value, $completion) {
        return yield* /*#__NOINLINE__*/withContextUndispatched(this.k1g_1, value, this.l1g_1, this.m1g_1, $completion);
      }
    }
    initMetadataForClass($, 'UndispatchedContextCollector', VOID, VOID, [FlowCollector()], [1]);
    UndispatchedContextCollectorClass = $;
  }
  return UndispatchedContextCollectorClass;
}
var StackFrameContinuationClass;
function StackFrameContinuation() {
  if (StackFrameContinuationClass === VOID) {
    class $ {
      constructor(uCont, context) {
        this.n1g_1 = uCont;
        this.o1g_1 = context;
      }
      pc() {
        return this.o1g_1;
      }
      rc(result) {
        this.n1g_1.rc(result);
      }
    }
    initMetadataForClass($, 'StackFrameContinuation', VOID, VOID, [Continuation()]);
    StackFrameContinuationClass = $;
  }
  return StackFrameContinuationClass;
}
//region block: exports
export {
  fuse$default as fuse$default1n688ovh0h7ac,
  ChannelFlowOperatorImpl as ChannelFlowOperatorImpl3gjkp847e0ebc,
  ChannelFlow as ChannelFlowvdfy82kdxy2m,
  FusibleFlow as FusibleFlow2tgh9s2p1kryd,
};
//endregion

//# sourceMappingURL=ChannelFlow.mjs.map
